import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {CreateCustomField} from 'shells/create-custom-field/create-custom-field';
import type {CreateCustomFieldResponse} from 'shells/create-custom-field/types';
import {FlashBanner} from 'shells/flash-banner/flash-banner';

import {CreateCustomFieldMutationWrapper} from '../../../../../core/custom-field/graphql/graphql-wrappers/create-custom-field-mutation-wrapper';
import type {CustomFieldView, DisplayType, EntityTypeFromApi} from '../../../../types';

import styles from './create-custom-field-block.module.css';

type Props = {
    customFieldType: CustomFieldView;
    name: string;
    onCreateSuccess: (
        customFieldId: string,
        displayType: DisplayType,
        entityType: EntityTypeFromApi
    ) => void;
    onClickBack: () => void;
};

export function CreateCustomFieldBlock(props: Props) {
    const saveButtonRef = React.useRef(undefined);

    let customFieldType;
    let displayType;
    switch (props.customFieldType) {
        case 'short-text':
            customFieldType = 'STRING';
            displayType = 'textfield';
            break;
        case 'long-text':
            customFieldType = 'TEXT';
            displayType = 'textarea';
            break;
        case 'checkbox':
            customFieldType = 'ENUM';
            displayType = 'checkboxes';
            break;
        case 'radio':
            customFieldType = 'ENUM';
            displayType = 'radio';
            break;
        case 'dropdown':
            customFieldType = 'ENUM';
            displayType = 'dropdown';
            break;
        case 'date':
            customFieldType = 'DATE';
            displayType = 'date';
            break;
    }

    // @ts-expect-error
    let allowMultiple;
    if (customFieldType === 'ENUM') {
        allowMultiple = props.customFieldType === 'checkbox';
    }

    return (
        <CreateCustomFieldMutationWrapper>
            {({onCreate, loading, error}) => (
                <div className={styles.container}>
                    {error ? (
                        <div className={styles['error-container']}>
                            <FlashBanner
                                type='error'
                                duration={2000}
                                animate={true}
                                isOverlay={true}
                                leftAlignContent={true}
                            >
                                {}
                                <div dangerouslySetInnerHTML={{__html: error}} />
                            </FlashBanner>
                        </div>
                    ) : undefined}
                    <div className={styles['custom-field']}>
                        <CreateCustomField
                            onCreate={(createCustomFieldVariables) =>
                                onCreate({
                                    customField: {...createCustomFieldVariables},
                                })
                            }
                            onCreateSuccess={(response: CreateCustomFieldResponse) => {
                                props.onCreateSuccess(
                                    response.customField.id,
                                    // @ts-expect-error
                                    displayType,
                                    response.entity
                                );
                            }}
                            createButtonRef={saveButtonRef}
                            name={props.name}
                            // @ts-expect-error
                            customFieldType={customFieldType}
                            // @ts-expect-error
                            enumIsAllowMultiple={allowMultiple}
                        />
                    </div>
                    <div className={styles['footer-buttons']}>
                        <ButtonMover size='big' direction='left'>
                            <Button size='big' variant='text' onClick={props.onClickBack}>
                                Back
                            </Button>
                        </ButtonMover>
                        <SaveButton
                            size='big'
                            buttonText='Create'
                            savingText='Creating…'
                            successText='Created'
                            isSaving={loading}
                            errorSaving={Boolean(error)}
                            getButtonRef={saveButtonRef}
                        />
                    </div>
                </div>
            )}
        </CreateCustomFieldMutationWrapper>
    );
}
